<template>
	<div class="header">
		<router-link :to="{name: 'products'}" class="logo">
			<img src="@/assets/images/logo.png"/>
		</router-link>

		<div class="filter" v-if="routerLoaded && categories">
			<div class="box">
				<vSelect v-bind="{categories}" @update="update"/>
				<vSearch @update="update"/>
			</div>
		</div>

		<nav class="nav">
			<router-link :to="{name: 'products'}">Produkter</router-link>
			<router-link :to="{name: 'orders'}">Ordrehistorik</router-link>
			<router-link :to="{name: 'news'}">Nyheder</router-link>
			<router-link :to="{name: 'contact'}">Kontakt</router-link>
			<a @click="logout">Logud</a>
			<a class="cart" @click="minicart">
				<div class="icon" v-html="require('@/assets/icons/shopping-cart.svg')"/>
				<div class="count" v-text="itemsCount"/>
			</a>
		</nav>
	</div>
</template>

<script>
import vSearch from "./search.vue";
import vSelect from "./select.vue";

export default {
	components: {vSelect, vSearch},
	props: {
		categories: {type: Array, required: true},
		routerLoaded: {type: String, required: true},
		itemsCount: {type: Number, required: true},
		update: {type: Function, required: true},
		logout: {type: Function, required: true},
		minicart: {type: Function, required: true}
	}
};
</script>

<style lang="scss" scoped>
.header {
	z-index: 3;
	background-color: $white1;
	height: $header;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	padding: 0 em(34);
	box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.10000000149011612);

	display: flex;
	align-items: center;

	.logo {
		flex-shrink: 0;

		img {
			display: block;
			width: em(130);

			@include res(small) {
				width: em(90);
			}
		}
	}

	.filter {
		margin-left: 5%;

		@include res(small) {
			margin-left: 1.25em;
			font-size: 0.9em;
		}

		.box {
			box-shadow: 0 2px 4px 0 #F4F6F8;
			display: flex;

			> div {
				border: 1px solid #E1E5E7;
				display: flex;
				align-items: center;
				height: em(50);
				padding: 0 24px;
			}
		}
	}
	.nav {
		margin-left: auto;
		display: flex;
		align-items: center;

		a {
			margin-left: 32px;
			font-size: em(14);

			@include res(1220) {
				margin-left: 16px;
			}
		}

		.cart {
			user-select: none;
			position: relative;
			display: none;

			@include res(small) {
				display: inline;
			}

			.icon {
				/deep/ svg {
					$s: 20px;
					width: $s;
					height: $s;
				}
			}
			.count {
				position: absolute;
				top: -1em;
				right: -2em;
				font-size: 9px;
				padding: 3px 6px;
				background-color: $black1;
				border-radius: 13px;
				color: $white1;
			}
		}
	}
}
</style>
